/**
 * Format a price value with currency
 * @param {string|number} price - Price value
 * @param {string} currency - Currency code (e.g. 'RUB', 'USD', 'TRY')
 * @returns {string} Formatted price
 */
export default function formatPrice(price, currency) {
  const num = typeof price === 'string' ? parseFloat(price) : price;
  if (isNaN(num)) return '';

  // Format number with spaces as thousands separator
  const formatted = Math.round(num)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0');

  const symbols = {
    RUB: '\u20BD',
    USD: '$',
    EUR: '\u20AC',
    TRY: '\u20BA',
    KZT: '\u20B8',
  };

  const symbol = symbols[currency] || currency || '';
  return `${formatted}\u00A0${symbol}`;
}
